<template>
    <div v-if="show" id="snackbar" :class="show ? 'show' : 'none'" v-html="message" />
</template>
<script>
export default {
  componentName: 'PpvToast',
  data () {
    return {
      show: false,
      message: '',
      showToastTimer: null
    }
  },
  methods: {
    showToast (callbackFn, message) {
      clearTimeout(this.showToastTimer)
      this.message = message.replaceAll('\n', '<br>')
      this.show = true
      this.showToastTimer = setTimeout(() => {
        callbackFn()
        this.show = false
      }, 3000)
    },
    attachEvent () {
      this.$events.$on('OPEN_PPV_TOAST', this.showToast)
    },
    detachEvent () {
      this.$events.$off('OPEN_PPV_TOAST', this.showToast)
    }
  },
  mounted () {
    this.attachEvent()
  },
  beforeDestroy () {
    this.detachEvent()
  }
}
</script>
<style scoped>
  /* The snackbar - position it at the bottom and in the middle of the screen */
  #snackbar {
    visibility: hidden; /* Hidden by default. Visible on click */
    position: fixed; /* Sit on top of the screen */
    left: 50%; /* Center the snackbar */
    bottom: 60px; /* 30px from the bottom */
    padding: 27px 100px; /* Padding */
    background-color: #2f2f2f; /* Black background color */
    border-radius: 106px; /* Rounded borders */
    font-size: 18px;
    color: #fff; /* White text color */
    text-align: center; /* Centered text */
    line-height: 26px;
    transform: translateX(-50%);
    z-index: 3000; /* Add a z-index if needed */
  }

  /* Show the snackbar when clicking on a button (class added with JavaScript) */
  #snackbar.show {
    visibility: visible; /* Show the snackbar */
    /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
    However, delay the fade out process for 2.5 seconds */
    -webkit-animation: fadein 0.3s, fadeout 0.3s 3s;
    animation: fadein 0.3s, fadeout 0.3s 3s;
  }

  /* Animations to fade the snackbar in and out */
  @-webkit-keyframes fadein {
    from {opacity: 0;}
    to {opacity: 1;}
  }

  @keyframes fadein {
    from {opacity: 0;}
    to {opacity: 1;}
  }

  /*@-webkit-keyframes fadeout {*/
  /*  from {opacity: 1;}*/
  /*  to {opacity: 0;}*/
  /*}*/

  /*@keyframes fadeout {*/
  /*  from {opacity: 1;}*/
  /*  to {opacity: 0;}*/
  /*}*/
</style>
